export default __webpack_public_path__ + "a20fbbc61dae41f3806125ed9f7aa314.svg";